import React from 'react';
import { features } from '../../data/productContent';
export function FeatureStrip() {
  return <section aria-label="Key features" className="border-y border-ink bg-ink" data-id="element-183" data-mp="1kkzd9u4i8lvl">
      <ul className="mx-auto grid max-w-page divide-y divide-white/20 px-5 md:grid-cols-3 md:divide-x md:divide-y-0 md:px-10" data-id="element-184" data-mp="1gjdsznpn55bd">
        {features.map(f => <li key={f.title} className="py-8 md:px-8 md:py-10 md:first:pl-0 md:last:pr-0" data-id="element-185" data-mp="1bk9kz0egddmm">
            <h2 className="font-display text-2xl font-medium text-champagne" data-id="element-186" data-mp="16n0yinm9unfk">{f.title}</h2>
            <p className="mt-2 text-[15px] leading-relaxed text-white/90" data-id="element-187" data-mp="11ty64it8dk0y">{f.body}</p>
          </li>)}
      </ul>
    </section>;
}